import { createSlice } from "@reduxjs/toolkit";
import { loadTableState } from "../tables local storage";

const createTableInitialState = (tableId) => {
  const savedState = loadTableState(tableId) || {};

  return {
    sorting: savedState.sorting || [],
    columnVisibility: savedState.columnVisibility || {},
    columnOrder: savedState.columnOrder || [],
    columnFilters: savedState.columnFilters || [],
    columnSizing: savedState.columnSizing || {},
    density: savedState.density || "comfortable",

    tableData: [],
    tableHeaders: [],
    formattedHeaders: [],
    customHeaders: [],
    newPrioColumnOrder: [],
  };
};

const ConnectedDevicesSlicer = createSlice({
  name: "tables",
  initialState: {},
  reducers: {
    initTable: (state, action) => {
      const { tableId } = action.payload;
      if (!state[tableId]) {
        state[tableId] = createTableInitialState(tableId);
      }
    },
    setTableData: (state, action) => {
      const { tableId, tableData } = action.payload;

      if (state[tableId]) state[tableId].tableData = tableData;
    },
    setTableHeaders: (state, action) => {
      const { tableId, tableHeaders } = action.payload;
      if (state[tableId]) state[tableId].tableHeaders = tableHeaders;
    },
    setFormattedHeaders: (state, action) => {
      const { tableId, formattedHeaders } = action.payload;
      if (state[tableId]) state[tableId].formattedHeaders = formattedHeaders;
    },
    setCustomHeaders: (state, action) => {
      const { tableId, customHeaders } = action.payload;
      if (state[tableId]) state[tableId].customHeaders = customHeaders;
    },
    setSorting: (state, action) => {
      const { tableId, updater } = action.payload;
      if (typeof updater !== "function") return;
      const newSorting = updater(state[tableId].sorting);
      if (state[tableId]) state[tableId].sorting = newSorting;
    },
    setColumnVisibility: (state, action) => {
      const { tableId, updater } = action.payload;
      if (typeof updater !== "function") return;
      const newColumnsVisibility = updater(state[tableId].columnVisibility);
      if (state[tableId])
        state[tableId].columnVisibility = newColumnsVisibility;
    },
    setColumnOrder: (state, action) => {
      const { tableId, newColumnOrder, isPrioColumns } = action.payload;
      if (!state[tableId]) return;
      if (
        !isPrioColumns ||
        state[tableId].columnOrder?.length !== newColumnOrder?.length
      )
        state[tableId].columnOrder = newColumnOrder;
      else state[tableId].newPrioColumnOrder = newColumnOrder;
    },
    setColumnSizing: (state, action) => {
      const { tableId, updater } = action.payload;
      if (typeof updater !== "function") return;
      const newSizing = updater(state[tableId].columnSizing);

      if (state[tableId]) state[tableId].columnSizing = newSizing;
    },
    setDensity: (state, action) => {
      const { tableId, newDensity } = action.payload;
      if (state[tableId]) state[tableId].density = newDensity;
    },
    setColumnFilters: (state, action) => {
      const { tableId, updater } = action.payload;

      if (typeof updater != "function") return;
      const newColumnFilters = updater(state[tableId].columnFilters);

      if (state[tableId]) state[tableId].columnFilters = newColumnFilters;
    },
    //! BE CAREFUL! This will reset all filters and set the new one. Use carefully!
    setManualFilters: (state, action) => {
      const { tableId, filters } = action.payload;

      if (!state[tableId] || !Array.isArray(filters)) return;

      state[tableId].columnFilters = filters;
    },
    //! BE CAREFUL! This will reset all columns visibility and set the new one. Use carefully!
    setManualVisibility: (state, action) => {
      const { tableId, visibility } = action.payload;

      if (!state[tableId] || typeof visibility !== "object") return;

      state[tableId].columnVisibility = visibility;
    },
    resetTable: (state, action) => {
      const tableId = action.payload;
      if (state[tableId]) {
        state[tableId].sorting = [];
        state[tableId].columnVisibility = {};
        state[tableId].columnOrder = [
          "mrt-row-select",
          ...state[tableId].tableHeaders,
        ];
        state[tableId].columnSizing = {};
        state[tableId].columnFilters = [];
        state[tableId].density = "comfortable";
      }
    },
    clearTableData: (state, action) => {
      const tableId = action.payload;
      if (state[tableId]) {
        state[tableId].tableData = [];
        state[tableId].tableHeaders = [];
        state[tableId].formattedHeaders = [];
        state[tableId].customHeaders = [];
      }
    },

    setBunchTableSettings: (state, action) => {
      const { tableId, newValues } = action.payload;

      if (!state[tableId]) return;

      state[tableId].sorting = newValues.sorting ?? [];
      state[tableId].columnVisibility = newValues.columnVisibility ?? {};
      state[tableId].columnOrder = newValues.columnOrder ?? [];
      state[tableId].columnFilters = newValues.columnFilters ?? [];
      state[tableId].columnSizing = newValues.columnSizing ?? {};
      state[tableId].density = newValues.density ?? "comfortable";
    },
  },
});

export const {
  initTable,
  setTableData,
  setTableHeaders,
  setFormattedHeaders,
  setCustomHeaders,
  setSorting,
  setColumnVisibility,
  setColumnOrder,
  setColumnSizing,
  setDensity,
  resetTable,
  clearTableData,
  setColumnFilters,
  setManualFilters,
  setManualVisibility,
  setBunchTableSettings,
} = ConnectedDevicesSlicer.actions;

export default ConnectedDevicesSlicer.reducer;
